module.exports = __webpack_public_path__ + "img/kieswijsanalyse_logo.b062faa2.png";